<template>
    <div :class="{'form_item': ! isFilter, 't_filter_item': isFilter}" >
        <p class="form_item_title" v-if="label !== false">
            <span v-text="label"></span>
            <i class="fas fa-spinner fa-spin" v-if="loading"></i>
        </p>
        <input type="hidden" :name="name" :value="selected_id">

        <div class="list-tit" v-if="selected_id">
            <li class="list-item">
                <div class="list-body">
                    <div class="mt-2 float-right">
                        <a @click.prevent="cancel">
                            <svg width="12" height="12" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17 1L1 17" stroke="#2C2A44" stroke-width="2"></path>
                                <path d="M1 1L17 17" stroke="#2C2A44" stroke-width="2"></path>
                            </svg>
                        </a>
                    </div>
                    <div v-text="selected.name" class="text-nowrap py-2 company-group-name"></div>
                </div>
            </li>
        </div>

        <div class="dropdown show" v-if="! selected_id">
            <div class="list-tit-pref">
                <input type="text" class="form_field_input" @click="search" :placeholder="placeholder" @input="debounceInput" :value="query">
                <div class="list-tit-pref_close" v-if="list.length">
                    <a @click.prevent="cancel" v-if="! loading">
                        <svg width="12" height="12" viewBox="0 0 18 18" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 1L1 17" stroke="#2C2A44" stroke-width="2"></path>
                            <path d="M1 1L17 17" stroke="#2C2A44" stroke-width="2"></path>
                        </svg>
                    </a>
                    <i class="fas fa-spin fa-spinner" v-if="loading"></i>
                </div>
            </div>
            <div class="dropdown-menu dropdown-menu-scale styledDW" v-if="list.length" v-click-outside="cancel">
                <li class="list-item" @click="select(group)" v-for="group in list" :key="group.id">
                    <div class="list-body">
                        <div v-text="group.name"></div>
                    </div>
                </li>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CompanyGroupSelectComponent",

    props: [
        'value',
        'name',
        'event',
        'label',
        'placeholder',
        'isFilter',
    ],

    data() {
        return {
            loading: false,

            query: null,

            list: [],

            selected: null,
        };
    },

    mounted() {
        if(this.value) {
            this.findSelected(this.value);
        }
    },

    watch: {
        query: function () {
            this.search();
        },
    },

    computed: {
        selected_id: function () {
            if(! this.selected) {
                return null;
            }

            return this.selected.id;
        },

        language: function () {
            if(location.pathname.indexOf('/en') === 0) {
                return '/en';
            }

            return '';
        }
    },

    methods: {
        debounceInput: _.debounce(function (e) {
            this.query = e.target.value;
        }, 500),

        search() {

            this.loading = true;

            axios.post(`${this.language}/company-groups?query=${this.query}`)
                .then((response) => {
                    if(response.data.status === 'success') {
                        this.list = response.data.groups;
                    } else {
                        console.log(response);

                        this.$eventBus.$emit('alert', 'error', 'Виникла невідома помилка під час завантаження списку груп компаній.', true, 3);
                    }

                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;

                    console.error(error);

                    this.$eventBus.$emit('alert', 'error', 'Виникла невідома помилка під час завантаження списку груп компаній.', true, 5);
                });
        },

        findSelected(id) {
            this.loading = true;

            axios.post(`${this.language}/company-groups?id=${id}`)
                .then((response) => {
                    if(response.data.status === 'success') {
                        this.selected = response.data.group;
                    } else {
                        console.log(response);

                        this.$eventBus.$emit('alert', 'error', 'Виникла невідома помилка під час завантаження обраної групи компаній.', true, 3);
                    }

                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;

                    console.error(error);

                    this.$eventBus.$emit('alert', 'error', 'Виникла невідома помилка під час завантаження обраної групи компаній.', true, 5);
                });
        },

        select(group) {
            this.selected = group;

            this.$emit('input', this.selected_id);

            if(this.event) {
                Livewire.emit(this.event, this.name, this.selected_id);
                this.$eventBus.$emit(this.event, this.name, this.selected_id);
            }
        },

        cancel() {
            this.list = [];
            this.query = null;
            this.selected = null;

            this.select(null);
        },

        blur() {
            console.log('blur');
        }
    },
}
</script>

<style scoped>
.company-group-name {
    font-size: 14px;
}
</style>
